import ClientRow from "./ClientRow";
import "../../styles/table.css";

export default function ClientTable({ clients, onView, onWalletAction}) {
  return (
    <div className="tableCard">
      <table className="modernTable">
        <thead>
          <tr>
            <th>Client</th>
            <th>Téléphone</th>
            <th>Solde</th>
            <th className="center">Actions</th>
          </tr>
        </thead>

        <tbody>
          {clients.map((client) => (
            <ClientRow
              key={client.id}
              client={client}
              onView={onView}
              onWalletAction={onWalletAction}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
